export default __webpack_public_path__ + "assets/d4e5bf821611200297b748132b352aff.svg";